import { Button, Divider, Stack, Typography, Box } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ScheduleIcon from '@mui/icons-material/Schedule'
import HomeIcon from '@mui/icons-material/Home'
import NextLink from 'next/link'
import { pagesPath } from '~/lib/$path'
import { CampaignPostFooter } from '~/components/CampaignPostFooter'
import { colorPalette } from '~/constants/styles/colors'
import { CenteredCardLayout } from '~/components/layout/CenteredCardLayout'

/**
 * 提出完了のヘッダーセクション
 */
const SuccessHeader = () => {
  return (
    <Stack gap={2}>
      <Stack direction="row" gap={2} alignItems="center">
        <CheckCircleIcon sx={{ color: colorPalette.success.main, fontSize: 40 }} />
        <Typography variant="headingM" fontWeight="bold">
          提出完了
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        キャンペーンを審査に提出しました！
      </Typography>
    </Stack>
  )
}

/**
 * ホームに戻るボタン
 */
const BackHomeButton = () => (
  <NextLink href={pagesPath.home.$url().pathname} passHref legacyBehavior>
    <Button variant="outlined" fullWidth startIcon={<HomeIcon />}>
      ホームに戻る
    </Button>
  </NextLink>
)

/**
 * メインコンポーネント
 */
export const CreateSuccess = () => {
  return (
    <CenteredCardLayout>
      <Box sx={{ mb: 4 }}>
        <SuccessHeader />
      </Box>

      <Divider sx={{ my: 3 }} />

      <BackHomeButton />
    </CenteredCardLayout>
  )
}
